module.exports = __webpack_public_path__ + "img/featureSlide04Img_02.754e2371.png";